import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { InviteUserRequest } from '../models/invite-user-request.model';
import { User } from '../models/user.model';
import { TerminateUserRequest } from '../models/terminate-user-request.model';


export const UserActionGroup = createActionGroup({
  source: 'Users',
  events: {
    'Get Users Requested': emptyProps(),
    'Get Users Success': props<{ users: Array<User>; }>(),
    'Get Users Failure': props<{ error: any; }>(),
    'Add User Requested': props<{ user: InviteUserRequest; }>(),
    'Add User Success': props<{ response: Response; }>(),
    'Add User Failure': props<{ error: any; }>(),
    'Edit User Requested': props<{ user: User; }>(),
    'Edit User Success': props<{ user: User; }>(),
    'Edit User Failure': props<{ error: any; }>(),
    'Delete User Requested': props<{ id: string; }>(),
    'Delete User Success': props<{ user: User; }>(),
    'Delete User Failure': props<{ error: any; }>(),
    'Terminate User Requested': props<{ id: string; request: TerminateUserRequest; }>(),
    'Terminate User Success': emptyProps(),
    'Terminate User Failure': props<{ error: any; }>(),
    'Update Selected Users': props<{ users: Array<User> }>()
  }
})
